var map = {
	"./game-00-hallo-welt/game.js": "./src/lib/edu/game-00-hallo-welt/game.js",
	"./game-01-weltraum-maus/game.js": "./src/lib/edu/game-01-weltraum-maus/game.js",
	"./game-02-maus-blinzelt/game.js": "./src/lib/edu/game-02-maus-blinzelt/game.js",
	"./game-03-maus-tanzt/game.js": "./src/lib/edu/game-03-maus-tanzt/game.js",
	"./game-04-wimmelbild/game.js": "./src/lib/edu/game-04-wimmelbild/game.js",
	"./game-05-mathefant/game.js": "./src/lib/edu/game-05-mathefant/game.js",
	"./game-06-listen-und-variablen/game.js": "./src/lib/edu/game-06-listen-und-variablen/game.js",
	"./game-07-kunst-mit-der-maus/game.js": "./src/lib/edu/game-07-kunst-mit-der-maus/game.js",
	"./game-08-kugelfisch/game.js": "./src/lib/edu/game-08-kugelfisch/game.js",
	"./game-09-wort-spiel/game.js": "./src/lib/edu/game-09-wort-spiel/game.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lib/edu sync recursive game.+\\/game\\.js$";